module.exports = __webpack_public_path__ + "static/media/IMG-2.97611490.jpg";